
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
    attributeName: 'tableContentLifeCycleMonitor',
    getURL: 'live/contentLifeCycleLogs',
    canOpen: false,
    canEdit: false,
    canCreate: false,
    canRemove: false,
    emptyMessage: "No logs to display",
    rowHighlight: [
        {
        key: "type",
        value: "Content",
        class: "highlight-row-clear"
      },
      {
        key: "type",
        value: "Detail",
        class: "highlight-row-dark"
        },    
    ],
    collapsable: {
        key: "type",
        relation: "id",
        values: {
            master: "Content",
            slave: "Detail"
        }
    },
  emptyMessage: "You have no logs.",
  fields: [
    {
      attributeName: 'id',
      label: 'Content ID',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '12rem',
      canFilter: true
    },
    {
      attributeName: 'date',
      label: 'Date',
      type: FormInputTypes.CELL_DATE,
      mode:"datetime",
      width: '12rem',
      helpText: 'Cloud/ingest',
      canFilter: true
    },    
    {
      attributeName: 'status',
      label: 'Status',
      type: FormInputTypes.TEXT,
      width: '12rem',
      canFilter: true
    },
    {
      attributeName: 'user',
      label: 'User',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      width: '12rem',
      default: '-',
      canFilter: true
    },
  ],
};
